import type { RealtimeClient } from "./realtime-client";

// 参照専用の埋め込みモード用の静的（no-op）リアルタイムクライアント。
//
// 埋め込みでは WebSocket に接続せず、ロード時点のスナップショット（REST bootstrap で doc store に
// ロード済み）だけを表示する。ディスパッチャやカーソルブロードキャスタが `useRealtimeClient()` を
// 前提にしているため provider は必要だが、送受信は一切行わない。mock-realtime は自分の op を
// エコーバックして doc を書き換えてしまうため、参照専用には使わず、本当に何もしない実装にする。
export function createStaticRealtimeClient(): RealtimeClient {
  const noopUnsubscribe = (): void => {
    // 購読解除は何もしない。
  };
  return {
    connect: async () => {
      // 接続しない（スナップショットは REST bootstrap 済み）。
    },
    disconnect: () => {
      // 何もしない。
    },
    sendOp: () => {
      // 参照専用のため送信しない。
    },
    sendMessage: () => {
      // 参照専用のため送信しない。
    },
    onMessage: () => noopUnsubscribe,
    onClose: () => noopUnsubscribe,
    onReopen: () => noopUnsubscribe,
  };
}
